
export const InstagramIcon = ({
  children,
  className,
  ...props
}: React.SVGProps<SVGSVGElement>): React.JSX.Element => {
  return (
    <svg className={className}
      {...props}
    >
      {children}
      <use href="#instagram" />
    </svg>
  );
};
